import { Injectable, inject } from '@angular/core'
import { Actions, createEffect } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import {
  debounceTime,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators'
import { State } from '../state'
import { onComplete, onCreate } from '../../../shared/utils/redux/operators'
import { WsEventsActions } from './ws-events.actions'
import { JobsiteSummaryActions } from '../../../jobsites-management/jobsite-summary/store/jobsite-summary.actions'
import { needToCenterMapOnColumnReload } from '../../../jobsites-management/jobsite-summary/store/jobsite-summary.selectors'

@Injectable()
export class WsEventsEffects {
  private readonly actions$ = inject(Actions)
  private readonly store = inject<Store<State>>(Store)

  handleEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        onCreate(WsEventsActions.handleEvent),
        map(a => a.payload),
        map(event => {
          switch (event) {
            case 'RELOAD_LAYOUT': {
              this.store.dispatch(
                JobsiteSummaryActions.centerMapOnColumnReload.create(true),
              )
              return this.store.dispatch(
                JobsiteSummaryActions.loadJobsiteColumns.createStart(),
              )
            }
          }
        }),
      ),
    { dispatch: false },
  )

  centerMap$ = createEffect(() =>
    this.actions$.pipe(
      onComplete(JobsiteSummaryActions.loadJobsiteColumns),
      debounceTime(400),
      map(a => a.payload?.map(c => c.key.id)),
      withLatestFrom(this.store.select(needToCenterMapOnColumnReload)),
      filter(([_, needToCenter]) => needToCenter),
      mergeMap(([ids, _]) => [
        JobsiteSummaryActions.setColumnIdsToFit.createSetItems(ids),
        JobsiteSummaryActions.centerMapOnColumnReload.create(false),
      ]),
    ),
  )
}
